<template>
	<form @submit.prevent="createVehicle()">
		<div class="row">
			<div class="col-sm-8">
				<div class="row">
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="tag"
							label="Vehicle Type"
							type="text"
							v-model="data.vehicleType"
							class="form-control form-control-lg dashInput"
							rules="required|min:3|max:40"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="seatingCapacity"
							label="Seating Capacity"
							type="number"
							v-model="data.seatingCapacity"
							class="form-control form-control-lg dashInput"
							rules="required"
							@valError="valError"
							@valSuccess="valSuccess"
							:min="0"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4"></div>
					<div class="form-group col-sm-6 mt-2">
						<BaseButton
							class="btn btn-primary form-control form-control-lg"
							type="submit"
							label="Add Vehicle"
							:disabled="formState.disable"
							:loading="formState.isLoading"
						/>
					</div>
				</div>
			</div>
			<div class="col-sm-4 px-4">
				<h4 class="text-dark fs-4">Global Trip Holidays</h4>
				<p class="text-dark">
					Contacts are your customers you interact with in pursuit of a business
					opportunity.
				</p>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";
	import formCheck from "@/helpers/formCheckHelper";
	import BaseInput from "./BaseInput";
	import BaseButton from "./BaseButton";

	export default {
		name: "VehicleCreate",
		components: {
			BaseInput,
			BaseButton,
		},
		setup: () => {
			const data = reactive({
				vehicleType: null,
				seatingCapacity: null,
			});
			const formState = reactive({
				isLoading: false,
				disable: true,
			});

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			const createVehicle = async () => {
				changeFormLoadingState();
				formState.disable = true;

				if (validation.invalid.length) {
					toast.error("Incomplete form", true);
					changeFormLoadingState();
					return;
				}

				try {
					await API.privateRequest.post("vehicles", data);
					toast.success(
						{ message: "Vehicle created!", position: "topRight" },
						true,
					);
					changeFormLoadingState();
					data.vehicleType = null;
					data.seatingCapacity = null;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
					changeFormLoadingState();
					formState.disable = false;
				}
			};

			const validation = reactive({
				invalid: [],
				valid: [],
				nullable: [],
			});
			const nullable = [];
			//? checking conditions to enable or disable form login button
			const checkForm = (data) => {
				let inValLength = validation.invalid.length;
				let formInputs = Object.keys(data);
				let formNulls = Object.keys(data).filter(
					(input) => eval(`data.${input}`) === null,
				);
				let nullables = validation.nullable || [];
				let notNullable = [];

				let check = [];
				if (nullables.length) {
					for (let nullable of nullables) {
						for (let [index, formInput] of formInputs.entries()) {
							if (nullable === formInput) {
								delete formInputs[index];
								break;
							} else if (!formInput) break;
							else notNullable.push(formInput);
						}
					}
					notNullable = [...new Set(notNullable)];
					let notNullableInvalids = notNullable.flatMap((item) => {
						let catchInValid = validation.invalid.includes(item);
						return catchInValid;
					});
					//? removing falsy values from array
					check = notNullableInvalids.filter(Boolean);
				}
				let formInputsNulls = notNullable.map((field) =>
					formNulls.includes(field),
				);
				let nullCheck = formInputsNulls.filter(Boolean);

				if (!inValLength && !check.length && !nullCheck.length) {
					return true;
				} else return false;
			};

			//? adding and removing form fields from valid and invalid state
			const setFormVal = (data) => {
				if (validation.invalid.length) {
					const newInvalid = validation.invalid.filter(
						(error) => error.field !== data.field,
					);
					validation.invalid = newInvalid;
				}
				if (validation.valid.length) {
					const newValid = validation.valid.filter(
						(item) => item.field !== data.field,
					);
					validation.valid = newValid;
				}
				return;
			};

			// event handler for valError event
			const valError = (input) => {
				if (!nullable instanceof Array)
					return console.error("expects 3rd param to be type Array");
				validation.nullable = nullable;
				setFormVal(input);
				validation.invalid = [...validation.invalid, input];
				let check = checkForm(data);

				if (check) return (formState.disable = false);
				return (formState.disable = true);
			};

			const valSuccess = (input) => {
				validation.nullable = nullable;
				setFormVal(input);
				validation.valid = [...validation.valid, input];
				let check = checkForm(data);
				// if (check) return false;
				// return true;
				if (check) return (formState.disable = false);
				return (formState.disable = true);
			};

			return {
				data,
				formState,
				validation,
				createVehicle,
				valError,
				valSuccess,
			};
		},
	};
</script>
